import './expose-react';
import './Redux.server';

// Components
import ProductsView from '../Components/ProductsView/ProductsView';
import ProductsViewTableGallery from '../Components/ProductsView/ProductsViewTableGallery';
import renderForServer from './render-for-server';

global.Components = {
  ProductsView: (props) => renderForServer(ProductsView, props),
  ProductsViewTableGallery: (props) =>
    renderForServer(ProductsViewTableGallery, props),
};
